angular.module('wbServices').factory 'financialPlans',
['$location', 'finance', 'tax', ($location, finance, tax) ->
  monthlyRate = (rate) -> Math.pow(1 + rate, 1/12) - 1

  class Account
    constructor: (values) ->
      defaults =
        balance: 10000
        rate: 0.05
      _.extend(@, values)
      _.defaults(@, defaults)
      @currentBalance = @balance

    adjust: (amount) =>
      if amount >= 0
        amount = amount * @depositFactor if @depositFactor?
      else
        amount = amount * @withdrawFactor if @withdrawFactor?
      # We don't allow overdraft, if we overdraft we return the amount
      # otherwise we return 0 to indicate success
      newBalance = @currentBalance * (1 + monthlyRate(@rate)) + amount
      @currentBalance = Math.max(newBalance, 0)
      if amount >= 0
        amount
      else
        Math.min(newBalance, 0)

    reset: => @currentBalance = @balance

  class Payment
    monthlyPayment: => @payment * @paymentsPerYear / 12

    constructor: (values, defaults) ->
      defaults ?=
        paymentsPerYear: 12
        start: 0
      _.extend(@, values)
      _.defaults(@, defaults)

    getMonth: (month) =>
      if @start && @start > month
        0
      else if @end && @end <= month
        0
      else
        @monthlyPayment()

  class Income extends Payment

  class Expense extends Payment

  class Debt extends Payment
    constructor: (values) ->
      super(values)

    getMonth: (month) =>
      months = month - @start
      @currentBalance = finance.futureValueOfAnnuity(-@monthlyPayment(), monthlyRate(@rate), months, @balance)
      if @monthlyPayment() < @currentBalance
        @monthlyPayment()
      else
        Math.max(@currentBalance, 0)

  class FinancialPlan
    constructor: (values) ->
      defaults =
        start: 35 * 12
        end: 100 * 12
        incomes: {}
        expenses: {}
        accounts: {}
        debts: {}
      _.extend(@, values)
      _.defaults(@, defaults)

    realRate: =>
      finance.realRateOfReturn(@interestRate, @inflationRate)

    addDebt: (name, values) =>
      @debts[name] = new Debt(values)

    removeDebt: (name) => delete @debts[name]

    addIncome: (name, values) =>
      @incomes[name] = new Income(values)

    removeIncomes: (name) => delete @individuals[name]

    addExpense: (name, values) =>
      @expenses[name] = new Expense(values)

    addAccount: (name, values) =>
      @accounts[name] = new Account(values)

    removeExpenses: (name) => delete @expenses[name]

    getValues: (month) =>
      debts = _.mapValues(@debts, (x) => x.getMonth(month))
      debtsBalances = _.mapValues(@debts, 'currentBalance')
      expenses = _.mapValues(@expenses, (x) => x.getMonth(month))
      income = _.mapValues(@incomes, (x) => x.getMonth(month))
      accounts = _.mapValues(@accounts, 'currentBalance')
      values = _.merge({}, debtsBalances, expenses, income, accounts)
      values.totalIncome = _(income).values().sum()
      values.totalExpenses = _(expenses).values().sum()
      values.totalDebts = _(debts).values().sum()
      adjust = values.totalIncome - values.totalExpenses - values.totalDebts
      values.accountDeposits = {}
      savingsAccounts = _.pickBy(@accounts, (a) -> a.type is 'account')
      rrspAccounts = _.pickBy(savingsAccounts, (a) -> a.assetType is 'rrsp')
      tfsaAccounts = _.pickBy(savingsAccounts, (a) -> a.assetType is 'tfsa')
      otherAccounts = _.pickBy(savingsAccounts, (a) -> a.assetType is 'other')
      for k, v of savingsAccounts
        if adjust >= 0
          values.accountDeposits[k+'-deposit'] = v.adjust(adjust)
        else
          values.accountDeposits[k+'-deposit'] = 0
          adjust = v.adjust(adjust)
      values.rrsp = Math.max(_(rrspAccounts).values().sumBy('currentBalance'), 0)
      values.tfsa = Math.max(_(tfsaAccounts).values().sumBy('currentBalance'), 0)
      values.other = Math.max(_(otherAccounts).values().sumBy('currentBalance'), 0)
      values.totalAssets = Math.max(_(@accounts).values().sumBy('currentBalance'), 0)
      values.totalDebts = Math.max(_(@debts).values().sumBy('currentBalance'), 0)
      values.netWorth = values.totalAssets - values.totalDebts
      values.savings = _(savingsAccounts).values().sumBy('currentBalance')
      values.deposits = Math.max(adjust, 0)
      values.month = month
      values.year = month/12
      values

    execute: =>
      results = for month in [@start..@end - 1]
        @getValues(month)
      results

  createFinancialPlan: (values) ->
    return new FinancialPlan(values)
]
